import { Component, Input, OnInit } from '@angular/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner/progress-spinner';
import { RequestOptions } from 'src/app/model/RequestOptions';
import { LoaderService } from 'src/app/services/LoaderService';

@Component({
  selector: 'app-idin-demo-page',
  templateUrl: './idin-demo-page.component.html',
  styleUrls: ['./idin-demo-page.component.css'],
})
export class IdinDemoPageComponent implements OnInit {
  @Input()
  mode: ProgressSpinnerMode;

  constructor(private loaderService: LoaderService) {}

  loading = false;
  ngOnInit(): void {}

  goToIdentityVerifiedPage() {
    window.location.href =
      this.getMockRedirectPage() +
      '?trxid=0030000028044342&ec=914a58ef989141a19afb153b6589b3ff&status=Success';
  }
  goToIdinCancelledPage() {
    window.location.href =
      this.getMockRedirectPage() +
      '?trxid=0030000028044342&ec=914a58ef989141a19afb153b6589b3ff&status=Cancelled';
  }
  goToIdinErrorPage() {
    window.location.href =
      this.getMockRedirectPage() +
      '?trxid=0030000028044342&ec=914a58ef989141a19afb153b6589b3ff&status=Error';
  }
  goToIdinVerificationFailedPage() {
    window.location.href =
      this.getMockRedirectPage() +
      '?trxid=0030000028044342&ec=914a58ef989141a19afb153b6589b3ff&status=Failed';
  }
  goToIdinVerificationMismatchPage() {
    window.location.href =
      this.getMockRedirectPage() +
      '?trxid=0030000028044342&ec=914a58ef989141a19afb153b6589b3ff&status=Mismatch';
  }
  goToIdinVerificationExpiredPage() {
    window.location.href =
      this.getMockRedirectPage() +
      '?trxid=0030000028044342&ec=914a58ef989141a19afb153b6589b3ff&status=Expired';
  }
  goToIdinVerificationOpenPage() {
    this.loaderService.show();
    setTimeout(() => {
      window.location.href =
        this.getMockRedirectPage() +
        '?trxid=0030000028044342&ec=914a58ef989141a19afb153b6589b3ff&status=Open';
    }, 7000);
  }
  getMockRedirectPage(): string {
    const currentURL = window.location.href;
    let configHref = '';
    if (currentURL.includes('/applicationrequester')) {
      configHref = currentURL.split('/#')[0];
    } else {
      configHref = window.location.origin;
    }
    let merchatUrl = configHref.concat('/#/idinVerificationIssuerResponse');
    return merchatUrl;
  }
}
